import type {
  AccountAanmakenInput,
  AuthUser,
  HerstelCheck,
  HerstelInput,
  LoginInput,
  UitnodigingCheck,
} from '@vip/shared';
import { api } from '../../lib/apiClient';

export const authApi = {
  me: () => api.get<{ user: AuthUser | null }>('/auth/me'),
  login: (input: LoginInput) => api.post<{ user: AuthUser }>('/auth/login', input),
  logout: () => api.post<{ ok: true }>('/auth/logout'),

  /** De uitleg is gezien; hij gaat daarna niet meer vanzelf open. */
  uitlegGezien: () => api.post<{ ok: true }>('/auth/uitleg-gezien'),

  /** Publiek: hoort bij de uitnodigingslink uit de mail. Een 410 betekent dat de
   *  link verlopen, al gebruikt of onbekend is. */
  checkUitnodiging: (token: string) =>
    api.get<UitnodigingCheck>(`/auth/uitnodiging/${encodeURIComponent(token)}`),
  maakAccount: (token: string, input: AccountAanmakenInput) =>
    api.post<{ user: AuthUser }>(`/auth/uitnodiging/${encodeURIComponent(token)}`, input),

  /** Publiek. Antwoordt altijd `ok`, ook bij een onbekend adres: of iemand een
   *  account heeft is niets dat dit formulier hoort te verklappen. */
  vraagHerstel: (email: string) => api.post<{ ok: true }>('/auth/wachtwoord-vergeten', { email }),

  /** Publiek: hoort bij de herstellink uit de mail. Een 410 betekent dat de link
   *  verlopen, al gebruikt of onbekend is. */
  checkHerstel: (token: string) =>
    api.get<HerstelCheck>(`/auth/herstel/${encodeURIComponent(token)}`),
  zetNieuwWachtwoord: (token: string, input: HerstelInput) =>
    api.post<{ user: AuthUser }>(`/auth/herstel/${encodeURIComponent(token)}`, input),
};
